import { render, staticRenderFns } from "./EducationalPeriods.vue?vue&type=template&id=3ccd9ff2&"
import script from "./EducationalPeriods.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports